module.exports = "/_next/static/images/9887517ed5754dba29bf3043da37f8a4-hero-experiment-lg.jpg.webp";